<script>
  import "@spectrum-css/menu/dist/index-vars.css"
</script>

<ul class="spectrum-Menu" role="menu">
  <slot />
</ul>
